var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFb = function SvgIconFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.071 4.929c3.905 3.905 3.905 10.237 0 14.142s-10.237 3.905-14.142 0-3.905-10.237 0-14.142 10.237-3.905 14.142 0m-6.218 14.617h-2.728v-6.293H7.831v-2.542h2.294V8.82c0-1.891 1.116-3.472 3.131-3.348l2.108.093v2.108h-1.178c-.65 0-1.333.403-1.333 1.116v1.922h2.418l-.403 2.542h-2.015z",
    clipRule: "evenodd"
  })));
};
export default SvgIconFb;